import { render, staticRenderFns } from "./ImagerieViewer.vue?vue&type=template&id=8a08c6d4&scoped=true&"
import script from "./ImagerieViewer.vue?vue&type=script&lang=js&"
export * from "./ImagerieViewer.vue?vue&type=script&lang=js&"
import style0 from "./ImagerieViewer.vue?vue&type=style&index=0&id=8a08c6d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a08c6d4",
  null
  
)

export default component.exports